<app-parameter-card [title]="title">
  <mat-form-field>
<!--    <mat-label>{{parameterData.name}}</mat-label>-->
    <select matNativeControl (change)="handle($event)" [value]="parameterData.value">
      <option *ngFor="let option of parameterData.options" [selected]="parameterData.value == option.value" [value]="option.value">{{option.name}}</option>
    </select>
  </mat-form-field>
</app-parameter-card>
